/**
 * Created by xuyq on 2021/3/29.
 */
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import './style.scss'

Vue.use(VXETable)
